import script from "./dataGenerate.vue?vue&type=script&setup=true&lang=js"
export * from "./dataGenerate.vue?vue&type=script&setup=true&lang=js"

import "./dataGenerate.vue?vue&type=style&index=0&id=e8c7ccba&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e8c7ccba"]])

export default __exports__